import React from "react";
import { Table } from "@dossier/salvia-ui";

export default function MinibeakHookResult() {
  return (
    <>
      <Table>
        <thead>
          <tr>
            <th>Field</th>
            <th>Type</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <code>isReady</code>
            </td>
            <td>boolean</td>
            <td>
              Whether the requested resource is available yet. This is always
              true after the initial fetch.
            </td>
          </tr>

          <tr>
            <td>
              <code>isFetching</code>
            </td>
            <td>boolean</td>
            <td>
              Whether this resource is currently being fetched or re-fetched.
            </td>
          </tr>

          <tr>
            <td>
              <code>data</code>
            </td>
            <td>Resource or array of resources</td>
            <td>The resource or resources returned directly by the call.</td>
          </tr>

          <tr>
            <td>
              <code>resources</code>
            </td>
            <td>Map of resource types to maps of resource ids to resources</td>
            <td>
              All of the resources returned by the call, including included
              resources.
            </td>
          </tr>

          <tr>
            <td>
              <code>response</code>
            </td>
            <td>Json response object</td>
            <td>
              The unprocessed json returned from ProFile. Useful for pagination.
            </td>
          </tr>

          <tr>
            <td>
              <code>error</code>
            </td>
            <td>Error</td>
            <td>
              Any errors that happened during the request. If the HTTP status
              was not in the 200-range, this will be a{" "}
              <code>
                <a href="#ResponseNotOkError">ResponseNotOkError</a>
              </code>
              , with a <code>.response</code> field containing the response
              itself. When <code>throwErrors</code> is set in the config, the
              error is thrown during render instead, so the nearest React error
              boundary catches it.
            </td>
          </tr>

          <tr>
            <td>
              <code>refresh</code>
            </td>
            <td>
              <code>() =&gt; Promise&lt;MinibeakResult&gt;</code>
            </td>
            <td>
              A function that can be called to run the fetch again, to refresh
              the data. This can be called manually when a resource is changed
              somewhere else. Resolves with the new result. It does not reject
              on a failed request, so <code>refresh().catch()</code> never
              fires: the error is in the result, or thrown during render when{" "}
              <code>throwErrors</code> is set.
            </td>
          </tr>
        </tbody>
      </Table>
    </>
  );
}
